import React from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

const NoData = () => {
    return (
        <div className={styles.wrap}>
            <div className={styles.icon} />
            <div className={styles.text}>此标签下暂无内容</div>
        </div>
    );
};

export default errorBoundary(NoData);
